export const LanguagesInAtlanta = [
  {
    heading: "Spanish",
    detail:
      "Spanish is spoken by the majority of Atlanta's population, after English. Spanish translation services are available for businesses and persons looking to transform their websites, documents, and apps from any other language into Spanish. If this is the ideal situation for you, reach out to Tomedes.",
    link: "/spanish-translation.php",
  },
  {
    heading: "French",
    detail:
      "Another popular language in Atlanta, French is also a major language in the world. For those looking to translate from English to French, French to English, or any other language pairs, there's many to choose from at Tomedes. If you're looking to expand your global footprint, get in touch now.",
    link: "/french-translation.php",
  },
  {
    heading: "Japanese",
    detail:
      "Japanese is also a major language spoken by Atlanta residents, and is one of the most used business languages in the world. Whether you're translating from Japanese to English and English to Japanese, do you want to interest this demographic in Atlanta or spread your horizons to worldwide Japanese consumers. If so, contact Tomedes.",
    link: "/japanese-translation.php",
  },
  {
    heading: "Chinese",
    detail:
      "After Spanish, Chinese is the most spoken language in Atlanta, according to statistical data. Atlanta has a Chinese population of 3,500 residents. Aside from that, Chinese is also a major business language in the world, and the country's GDP is the second largest in the world. If you're looking to appeal to this demographic, or go beyond Atlanta, contact us.",
    link: "/mandarin-chinese-translation",
  },
];
